import React, { Component } from 'react';
import { Spin } from 'antd';

class CpLoading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowHeight: 0
    };
  }
  componentDidMount() {
    this.setState({
      windowHeight: document.body.clientHeight
    });
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  render() {
    const { size } = this.props;
    const { windowHeight } = this.state;
    return (
      <div className="cp-loading" style={{ height: windowHeight }}>
        <div className="cp-loading-bg"></div>
        <Spin className="spin" size={size}></Spin>
      </div>
    );
  }
}

export default CpLoading;